import { useCallback } from 'react';
import cx from 'classnames';

import { CustomTypography } from 'src/components/CustomTypography';
import { FieldSelect } from 'src/components/FieldSelect';
import { FieldSelectMenuItem } from 'src/components/FieldSelectMenuItem';
import { StaticPanel } from 'src/components/StaticPanel';
import { GENERATION_TOOL } from 'src/data/generationTool';
import { getAspectRatioTitle, IMAGE_ASPECT_RATIO } from 'src/data/image';

import { ImageAspectRatioIcon } from './components/ImageAspectRatioIcon';
import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';
import { useViewState } from './useViewState';

const OPTIONS_NEW = [
  IMAGE_ASPECT_RATIO.ratio1x1,
  IMAGE_ASPECT_RATIO.ratio2x3,
  IMAGE_ASPECT_RATIO.ratio3x2,
];
const OPTIONS_OLD = [
  IMAGE_ASPECT_RATIO.ratio1x1,
  IMAGE_ASPECT_RATIO.ratio16x9,
  IMAGE_ASPECT_RATIO.ratio9x16,
  IMAGE_ASPECT_RATIO.ratio4x3,
];

export const BlockAspectRatio = ({
  className,
  generationTool,
  disabled,
  value,
  onChange,
  grayoutTitle,
}) => {
  const styles = useStyles();

  const { imageAspectRatio } = useViewState();
  const { handleChange } = useHandlers({ onChange });

  const options =
    generationTool === GENERATION_TOOL.imageWithDescription ? OPTIONS_OLD : OPTIONS_NEW;

  const renderOption = useCallback(
    (option) => {
      return (
        <div className={styles.option}>
          <ImageAspectRatioIcon
            className={styles.aspectIcon}
            aspectRatio={option}
          />
          <CustomTypography>{getAspectRatioTitle(option)}</CustomTypography>
        </div>
      );
    },
    [styles]
  );

  return (
    <StaticPanel
      className={cx(styles.root, className, { [styles.gray]: grayoutTitle })}
      title="Aspect ratio"
    >
      <FieldSelect
        value={value || imageAspectRatio}
        renderValue={renderOption}
        onChange={handleChange}
        disabled={disabled}
      >
        {options.map((option) => (
          <FieldSelectMenuItem
            className={styles.menuItem}
            key={option}
            value={option}
          >
            {renderOption(option)}
          </FieldSelectMenuItem>
        ))}
      </FieldSelect>
    </StaticPanel>
  );
};
